// src/pages/Services/Services.js
import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    // AI & Advanced Technologies
    {
      title: 'Agentic AI Implementation',
      icon: '🤖',
      description: 'Deploy intelligent AI agents that plan, decide, and act autonomously across enterprise workflows with sovereign and global LLMs.',
      features: [
        'AI Agents for Enterprise Automation',
        'Indian & Global LLM Integration',
        'Workflow Orchestration & Automation',
        'On-Premise & Cloud Deployment'
      ]
    },
    {
      title: 'Generative AI & Machine Learning',
      icon: '🧠',
      description: 'Advanced AI solutions including natural language processing, computer vision, predictive analytics, and custom AI model development.',
      features: [
        'Custom AI Model Development',
        'Natural Language Processing (NLP)',
        'Computer Vision & Image Recognition',
        'Predictive Analytics & Forecasting'
      ]
    },
    {
      title: 'AI Chatbots & Voice Agents',
      icon: '💬',
      description: 'Conversational AI for customer service, HR, field operations with multi-language support including Hindi and regional languages.',
      features: [
        'WhatsApp AI Bot Development',
        'Voice AI Call Automation',
        'Multilingual Support (9+ Languages)',
        'Sentiment Analysis & NLP'
      ]
    },
    {
      title: 'AI Analytics & Business Intelligence',
      icon: '📊',
      description: 'Transform data into actionable insights with AI-powered analytics, real-time dashboards, and predictive business intelligence.',
      features: [
        'AI-Driven Insights & Reporting',
        'Real-time Analytics Dashboards',
        'Data Engineering & Management',
        'Business Intelligence Solutions'
      ]
    },
    
    // Core IT Services
    {
      title: 'IT Infrastructure Solutions',
      icon: '🖥️',
      description: 'End-to-end IT infrastructure setup, cloud computing & hybrid solutions, network security & data protection.',
      features: [
        'Infrastructure Design & Setup',
        'Cloud Computing Solutions',
        'Network Security & Protection',
        'Data Backup & Disaster Recovery'
      ]
    },
    {
      title: 'Software & Web Development',
      icon: '💻',
      description: 'Custom software development, web applications, enterprise portals, and business process automation solutions.',
      features: [
        'Custom Software Development',
        'Web Application Development',
        'Portal Development (B2B/B2C)',
        'API Development & Integration'
      ]
    },
    {
      title: 'Mobile App Development',
      icon: '📱',
      description: 'Native and cross-platform mobile applications for iOS and Android with seamless ERP integration.',
      features: [
        'iOS & Android App Development',
        'Cross-Platform Solutions',
        'ERP-Integrated Mobile Apps',
        'Progressive Web Apps (PWA)'
      ]
    },
    {
      title: 'Enterprise Resource Planning (ERP)',
      icon: '🏢',
      description: 'Comprehensive ERP solutions for manufacturing, finance, HR, inventory, and supply chain management.',
      features: [
        'Custom ERP Development',
        'ERP Implementation & Integration',
        'Module Customization',
        'ERP Migration & Upgrades'
      ]
    },
    
    // Specialized Solutions
    {
      title: 'Cloud & Managed Services',
      icon: '☁️',
      description: 'Cloud migration, optimization, 24/7 IT support, managed services, and compliance solutions.',
      features: [
        'Cloud Migration & Strategy',
        'AWS, Azure, Google Cloud',
        'Managed IT Services 24/7',
        'Cloud Security & Compliance'
      ]
    },
    {
      title: 'IoT & Smart Solutions',
      icon: '📡',
      description: 'Internet of Things solutions for smart manufacturing, asset tracking, predictive maintenance, and connected devices.',
      features: [
        'IoT Platform Development',
        'Sensor Integration & Analytics',
        'Predictive Maintenance Systems',
        'Real-time Monitoring Solutions'
      ]
    },
    {
      title: 'Cybersecurity Solutions',
      icon: '🔒',
      description: 'Comprehensive security services including penetration testing, compliance, threat protection, and security audits.',
      features: [
        'Security Assessment & VAPT',
        'Data Encryption & Protection',
        'Compliance (GDPR, ISO, RBI)',
        'Security Monitoring & Response'
      ]
    },
    {
      title: 'RPA & Process Automation',
      icon: '⚙️',
      description: 'Robotic Process Automation to streamline repetitive tasks, improve efficiency, and reduce operational costs.',
      features: [
        'Workflow Automation',
        'Document Processing Automation',
        'Legacy System Integration',
        'Bot Development & Management'
      ]
    },
    
    // Business Applications
    {
      title: 'Payroll & HR Management',
      icon: '👥',
      description: 'Complete payroll processing, attendance tracking, leave management, and HR automation solutions.',
      features: [
        'Automated Payroll Processing',
        'Attendance & Leave Management',
        'Employee Self-Service Portal',
        'Compliance & Statutory Reports'
      ]
    },
    {
      title: 'E-Commerce Solutions',
      icon: '🛒',
      description: 'Full-featured e-commerce platforms with payment gateway integration, inventory management, and multi-vendor support.',
      features: [
        'Custom E-Commerce Development',
        'Payment Gateway Integration',
        'Multi-Vendor Marketplace',
        'Inventory & Order Management'
      ]
    },
    {
      title: 'Digital Marketing & SEO',
      icon: '📈',
      description: 'Comprehensive digital marketing services including SEO, social media marketing, PPC campaigns, and content marketing.',
      features: [
        'Search Engine Optimization (SEO)',
        'Social Media Marketing',
        'PPC & Google Ads',
        'Content Marketing & Strategy'
      ]
    },
    {
      title: 'Blockchain & Web3',
      icon: '⛓️',
      description: 'Blockchain development, smart contracts, cryptocurrency solutions, and decentralized applications (DApps).',
      features: [
        'Blockchain Development',
        'Smart Contract Development',
        'Cryptocurrency Solutions',
        'NFT & DeFi Solutions'
      ]
    }
  ];

  return (
    <div className="services-page page-content">
      <section className="page-banner">
        <div className="container">
          <h1>Our Services</h1>
          <p>Comprehensive IT & AI Solutions for Modern Businesses</p>
        </div>
      </section>

      <section className="services-intro">
        <div className="container">
          <div className="intro-content">
            <h2>What We Offer</h2>
            <div className="title-line centered"></div>
            <p>
              At Vista Elevations, we provide cutting-edge IT and AI solutions designed to empower businesses 
              with innovation, efficiency, and digital transformation. From Agentic AI to enterprise applications, 
              our expertise spans across multiple domains to ensure your business stays competitive in the AI-driven era.
            </p>
          </div>
        </div>
      </section>

      <section className="services-list">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-detail-card">
                <div className="service-header">
                  <div className="service-icon-large">{service.icon}</div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <div className="service-features">
                  <h4>Key Features:</h4>
                  <ul>
                    {service.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Let's discuss how our services can transform your business with AI and technology</p>
          <a href="/contact" className="btn btn-white">Contact Us Today</a>
        </div>
      </section>
    </div>
  );
};

export default Services;
